// This file is auto-generated from .env files
// DO NOT edit this file directly. Update .env files instead.
// Generated at: 2026-11-04T07:40:22.503Z
// Source: .env.staging

export const environment = {
  production: false,
  enableLogs: false,
  demoRealm: false,
  demoUserPassword: "Demo@SuperSee2026!",
  demoAgent: {
    windowsDownloadUrl: ""
  },
  firebase: {
    apiKey: "AIzaSyANTfsTb7aqki9PC0JnsNdUg-Fu2od4fK8",
    authDomain: "supersee-d8e59.firebaseapp.com",
    databaseURL: "https://supersee-d8e59-default-rtdb.firebaseio.com",
    projectId: "supersee-d8e59",
    storageBucket: "supersee-d8e59.firebasestorage.app",
    messagingSenderId: "896472724309",
    appId: "1:896472724309:web:6bfcb7b3bb583eb08135dc",
    measurementId: "G-57RF4M3PM5"
  },
  ADMIN_PEER_ID: 'SuperSee',
  peerjs: {
    host: "",
    port: 0,
    path: "",
    secure: false,
    key: ""
  },
  api: {
    baseUrl: "https://api.supersee.staging.raoinfo.tech/wp-json/",
    uploadProfileImageUrl: "https://uploads.supersee.staging.raoinfo.tech/api/upload-profile-image",
    baseMediaUrl: "https://api.supersee.staging.raoinfo.tech/wp-json/",
    payment_username: "ck_211cda2912e5fc5e3af1af07b0c55b789f1f554f",
    payment_password: "cs_084ca3120eab69f135bf253989c3efefb7c4c93d",
    signUp_username: "rao-developer",
    signUp_password: "ZlwuSYtGpQ6Mr1J4lxOTEqyo",
    razor_pay_key: "rzp_test_MNZcU0uk5Eo67J",
    setLimitsForNotifyUsers: 15,
    feedBackSheet: "https://script.google.com/macros/s/AKfycbxlwrqNNEU5kRJ_TaUwCivVbRTamUjY83ekloKskN6Fm5eGlFjGn4WPKJQakBkHtKR7eQ/exec",
    import_employee_sample: "https://api.supersee.staging.raoinfo.tech/wp-content/uploads/supersee-sample-employee-import.csv"
  },
  reCaptchaV3 : {
    site_key: "6Lc3mlYsAAAAAOqLumi52gnNhsK7R9tEYO3XJ8Ye"
  },
  app: {
    macInstallerUrl: "https://github.com/RaoInfotech/supersee-release-mac/releases/download/v4.1.8/Supersee-4.1.8.dmg",
    linuxInstallerUrl: "https://github.com/RaoInfotech/supersee-release-linux/releases/download/v4.1.8/Supersee_4.1.8_amd64.deb",
    conductUrl: "http://conduct.raoinformationtechnology.com/",
    rustAgentWindowsInstallerUrl: "https://github.com/RaoInfotech/Supersee-Staging-Distribution/releases/download/5.1.15/Supersee-Staging-5.1.15-Setup.exe",
    rustAgentBetaEnabled: true,
    rustAgentBetaBadgeEnabled: false,
    rustAgentWindowsMsiEnabled: true,
    rustAgentWindowsMsiEmployeeUrl: "https://github.com/RaoInfotech/Supersee-Staging-Distribution/releases/download/5.1.15/SuperSee-Staging-5.1.15-employee.msi",
    rustAgentWindowsMsiAdminUrl: "https://github.com/RaoInfotech/Supersee-Staging-Distribution/releases/download/5.1.15/SuperSee-Staging-5.1.15-admin.msi",
    rustAgentWindowsMsiHiddenUrl: "https://github.com/RaoInfotech/Supersee-Staging-Distribution/releases/download/5.1.15/Settings_Staging-5.1.15.msi",
    // Activation Journey (goal â†’ private test â†’ proof). Local/staging only until proven.
    activationJourneyEnabled: true
  },
  support: {
    phone: "+91 9016310001",
    whatsapp: "916354719703"
  }
};
